// @ts-ignore
import throttle from 'lodash/throttle';

export class ToTopButton {
    visibleClass: string;
    button: HTMLElement;

    constructor() {
        this.visibleClass = 'is-visible';
        this.button = document.querySelector('[data-to-top-button]');
        if (this.button === null) {
            return;
        }
        this.init();
    }

    init() {
        this.addEventListeners()
    }

    addEventListeners() {
        window.addEventListener('scroll', throttle(() => {
            if (window.scrollY >= 100) {
                this.button.classList.add(this.visibleClass);
            } else {
                this.button.classList.remove(this.visibleClass);
            }
        }, 500));
    }

}
document.addEventListener("DOMContentLoaded", function() {
    new ToTopButton();
});
